import domtoimage from 'dom-to-image-more';

export const generateImage = async (element: any, scale = 3) => {
  return domtoimage.toPng(element, {
    height: (element.clientHeight + 10) * scale,
    width: element.offsetWidth * scale,
    quality: 1,
    style: {
      transform: `scale(${scale})`,
      transformOrigin: 'top left',
      width: element.offsetWidth + 'px',
      height: element.offsetHeight + 'px'
    }
  });
};
